import {prepend as arrayPrepend} from '@packages/utilities/array';
import {mapArray} from '@packages/utilities/fp/utils';

import {Plugins} from '@packages/systems/wfdl';
import {
  TList,
  TText,
  TRecord,
  TTypeReference,
  TGeneric,
  functionOf,
} from '@packages/systems/wfdl-ast';
import {
  _$,
  forall,
  tyfun,
  a,
  b,
  call2,
  call3,
} from '@packages/utilities/wfdl-helpers';
import {TOption} from '@packages/systems/plugins/Option';

import {Append} from './Append';

export const plugin = Plugins.PrivilegedPlugin({
  values: {
    Prepend: {
      envType: {
        dataType: forall(['a'], tyfun([a, TList(a)], TList(a))),
        exported: 'hidden',
      },
      // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
      value: (x) => (xs: any) => arrayPrepend(x, xs),
    },
    'Fold Right': {
      envType: {
        dataType: forall(['a', 'b'], tyfun([tyfun([a, b], b), b, TList(a)], b)),
        exported: 'hidden',
        implicit: 'prefilledArgs',
      },
      // @ts-expect-error - TS7006 - Parameter 'f' implicitly has an 'any' type.
      value: (f) => (init: any) => (xs: any) =>
        // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'x' implicitly has an 'any' type.
        xs.reduceRight((acc, x) => f(x)(acc), init),
    },
    Map: {
      envType: {
        dataType: TGeneric({
          arg: 'ListElementType',
          body: TGeneric({
            arg: 'ResultListElementType',
            body: functionOf(
              functionOf(
                TTypeReference('ListElementType'),
                TTypeReference('ResultListElementType')
              ),
              functionOf(
                TList(TTypeReference('ListElementType')),
                TList(TTypeReference('ResultListElementType'))
              )
            ),
          }),
        }),
        exported: 'hidden',
      },
      value: mapArray,
    },
    Append,

    // TODO: Consolidate this with similar functions into a new plugin
    Lookup: {
      envType: {
        dataType: forall(
          ['a'],
          tyfun(
            [
              TText,
              TList(
                TRecord({
                  Name: TText,
                  Value: a,
                })
              ),
            ],
            TOption(a)
          )
        ),
        exported: 'hidden',
      },
      // @ts-expect-error - TS7006 - Parameter 'fieldName' implicitly has an 'any' type.
      value: (fieldName) => (listOfFields: any) => {
        for (const {Name, Value} of listOfFields) {
          if (Name === fieldName) return {tag: 'Some', val: Value};
        }

        return {
          tag: 'None',
          val: {},
        };
      },
    },
  },
});

export const prependRef = _$('List', 'Prepend');
export const prepend = call2(prependRef);

export const foldRightRef = _$('List', 'Fold Right');
export const foldRight = call3(foldRightRef);

export const lookupRef = _$('List', 'Lookup');
export const lookup = call2(lookupRef);

export const mapRef = _$('List', 'Map');
export const map = call2(mapRef);

export const appendRef = _$('List', 'Append');
export const append = call2(appendRef);
